module.exports = __webpack_public_path__ + "img/h-page4-46.f4526a51.png";